import * as R from 'ramda'
export const documentDelivery = {
  EMAIL: 'Email',
  MAIL: 'Mail',
  CARRIER_WEBSITE: 'Carrier Website'
}
export const documentDeliveryKeys = R.keys(documentDelivery)
export const documentDeliveryValues = R.values(documentDelivery)

export const yesOrNo = {
  YES: 'Yes',
  NO: 'No'
}
export const yesOrNoKeys = R.keys(yesOrNo)
export const yesOrNoValues = R.values(yesOrNo)

export const lineOfBusinessCode = {
  AGLIA: 'AGLIA',
  AGPP: 'AGPP',
  AGPR: 'AGPR',
  APKGE: 'APKGE',
  AUTOB: 'AUTOB',
  AUTOP: 'AUTOP',
  BANDM: 'BANDM',
  BLDRK: 'BLDRK',
  BMSBP: 'BMSBP',
  BOAT: 'BOAT',
  BOP: 'BOP',
  BOPGL: 'BOPGL',
  BOPPR: 'BOPPR',
  CFIRE: 'CFIRE',
  CGL: 'CGL',
  COMAR: 'COMAR',
  CONTR: 'CONTR',
  CPKGE: 'CPKGE',
  CRIM: 'CRIM',
  CUMBR: 'CUMBR',
  DFIRE: 'DFIRE',
  EO: 'EO',
  EPLI: 'EPLI',
  EQ: 'EQ',
  FIDUC: 'FIDUC',
  FINAR: 'FINAR',
  FLOOD: 'FLOOD',
  GARAG: 'GARAG',
  GLASS: 'GLASS',
  HLTH: 'HLTH',
  HOME: 'HOME',
  INMRC: 'INMRC',
  INMRP: 'INMRP',
  INTER: 'INTER',
  KIDRA: 'KIDRA',
  LIFE: 'LIFE',
  LL: 'LL',
  MHOME: 'MHOME',
  MTRCR: 'MTRCR',
  MTRTK: 'MTRTK',
  OCMRC: 'OCMRC',
  PHYS: 'PHYS',
  PL: 'PL',
  PUMBR: 'PUMBR',
  SCHPR: 'SCHPR',
  SFRNC: 'SFRNC',
  SIGNS: 'SIGNS',
  SMP: 'SMP',
  SURE: 'SURE',
  TRANS: 'TRANS',
  TRKRS: 'TRKRS',
  VALP: 'VALP',
  WIND: 'WIND',
  WORK: 'WORK',
  WORKV: 'WORKV'
}
export const lineOfBusinessCodeKeys = R.keys(lineOfBusinessCode)
export const lineOfBusinessCodeValues = R.values(lineOfBusinessCode)

export const quoteVia = {
  RATER_AND_CARRIER_WEBSITE: 'Rater & Carrier Website',
  CARRIER_WEBSITE: 'Carrier Website',
  ACORD_APPLICATION_SUBMIT: 'Acord / Application Submit',
  MGA_WEBSITE: 'MGA Website'
}
export const quoteViaKeys = R.keys(quoteVia)
export const quoteViaValues = R.values(quoteVia)

export const bindIssueVia = {
  CARRIER_WEBSITE: 'Carrier Website',
  ACORD_APPLICATION_SUBMIT: 'Acord / Application Submit',
  MGA_WEBSITE: 'MGA Website'
}
export const bindIssueViaKeys = R.keys(bindIssueVia)
export const bindIssueViaValues = R.values(bindIssueVia)
